import React, { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./regularization-approve-reject.css";
import FileUpload from "../FileUploads/FileUpload";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import SuccessModal from "../CustomModal/Success";
import FailedModal from "../CustomModal/Failed";

const RegularizationApproveReject = ({
  match,
  history,
  regularizationDetailsForManager,
  regularizationDetails = [],
  regularizeAttendance,
  approveRejectRegularization = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [inputList, setInputList] = useState({
    manager_remark: "",
  });

  useEffect(() => {
    (async () => {
      const listStatus = [0];
      setIsLoading(true);
      await regularizationDetailsForManager(1, listStatus,
        match?.params?.id,
        match?.params?.type
      );
      setIsLoading(false);
    })();
  }, [regularizationDetailsForManager]);

  const handleInputChange = (value, key) => {
    setInputList((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setShowModal(false);
  };

  const handleReject = async (e, id, type) => {
    e.preventDefault();
    const payload = {
      manager_remark: inputList?.manager_remark,
      id: id,
      type: type,
      status: 2,
    };

    setIsLoading(true);
    const res = await regularizeAttendance(payload);
    setShowModal(false);
    if (res.status == 200) {
      setShowModal(false);
    } else {
      setShowModal(false);
      toast.error(res.message);
    }
    setIsLoading(false);
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    const payload = {
      id: match?.params?.id,
      type: match?.params?.type,
      status: 1,
    };
    setIsLoading(true);
    const res = await regularizeAttendance(payload);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (approveRejectRegularization?.data !== undefined && approveRejectRegularization?.status === 200) {
      setMessage(approveRejectRegularization?.message);
      setIsSuccessModalOpen(true);
    } else if (approveRejectRegularization?.data !== undefined && approveRejectRegularization?.status !== 200) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(approveRejectRegularization?.message);
    }
  }, [approveRejectRegularization]);

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={message}
        url={`/manager-requests-list`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={message}
        url={`/manager-requests-list`}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Regularization Request"} history={history} />
            {regularizationDetails &&
              regularizationDetails?.data &&
              regularizationDetails?.data?.data &&
              regularizationDetails?.data?.data?.length > 0 &&
              regularizationDetails?.data?.data[0]?.regularization_type &&
              regularizationDetails?.data?.data[0]?.regularization_type == "REGULARIZATION" && (
                <div className="container-fluid common-bg">
                  <div className="container-fluid bootstrap snippets bg-white">
                    <div className="container">
                      <form>
                        <div className="form-group">
                          <label>Reason for missed attendance</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]
                                ?.reason_for_missed_attendance
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Location of work</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.location_of_work
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Date</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.regularization_date
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>From</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_in_time}
                          />
                        </div>
                        <div className="form-group">
                          <label>To</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_out_time}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="attachments">
                            Upload attachments
                          </label>
                          {/* <FileUpload
                            id={"addAttachment"}
                            accept=".png,.jpg,.jpeg"
                            documentUploadUrl={documentUploadUrlPublic}
                            documentUrlData={documentUrlDataPublic}
                            prefilledFilename={
                              regularizationDetails?.data?.data[0]?.attachment
                                ? "attachment"
                                : ""
                            }
                            onChange={() => {}}
                          /> */}
                        </div>
                          {regularizationDetails?.data?.data[0]?.attachment ? (
                          <button className="btn btn-primary btn-sm mb-4">
                              <a href={regularizationDetails?.data?.data[0]?.attachment} target="_blank" style={{'color': 'white'}}>
                                <i className="bi bi-download"></i> Download
                              </a>
                            </button>
                        ) : (
                          <p>No attachment available</p>
                        )}
                        <div className="form-group">
                          <label htmlFor="message">Reason</label>
                          <textarea
                            id="message"
                            className="date-time"
                            value={regularizationDetails?.data?.data[0]?.message}
                            disabled
                          ></textarea>
                        </div>
                        <div className="d-flex" style={{"justifyContent": "space-between"}}>
                            <button
                              className="btn btn-danger"
                              type="submit"
                              onClick={(e) => handleShow(e)}
                            >
                              Reject
                            </button>
                            <button
                              className="btn btn-primary"
                              type="submit"
                              onClick={handleApprove}
                            >
                              Approve
                            </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            {regularizationDetails &&
              regularizationDetails?.data &&
              regularizationDetails?.data?.data &&
              regularizationDetails?.data?.data?.length > 0 &&
              regularizationDetails?.data?.data[0]?.regularization_type &&
              regularizationDetails?.data?.data[0]?.regularization_type === "WOOO" && (
                <div className="container-fluid common-bg">
                  <div className="container-fluid bootstrap snippets bg-white">
                    <div className="container">
                      <form>
                        <div className="form-group">
                          <label>Requester Name</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.requester_name}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Requester Email</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.requester_email}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Check-in Date & Time</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_in_date}
                            disabled
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.check_out_date &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            undefined &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            null && (
                            <div className="form-group">
                              <label>Check-out Date & Time</label>
                              <input
                                className="date-time"
                                type="text"
                                value={
                                  regularizationDetails?.data?.data[0]?.check_out_date
                                }
                                disabled
                              />
                            </div>
                          )}
                        <div className="form-group">
                          <label>Check-in Message</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.check_in_comments
                            }
                            disabled
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.check_out_date &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            undefined &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            null && (
                            <div className="form-group">
                              <label>Check-out Message</label>
                              <input
                                className="date-time"
                                type="text"
                                value={
                                  regularizationDetails?.data?.data[0]
                                    ?.check_out_comments
                                }
                                disabled
                              />
                            </div>
                          )}
                          <div className="d-flex" style={{"justifyContent": "space-between"}}>
                              <button
                                className="btn btn-danger"
                                type="submit"
                                onClick={(e) => handleShow(e)}
                              >
                                Reject
                              </button>
                              <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={handleApprove}
                              >
                                Approve
                              </button>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={(e) => handleClose(e)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{"Reject Request"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            <textarea
              className="form-control form-control-user"
              placeholder="Remarks"
              onChange={(e) =>
                handleInputChange(e.target.value, "manager_remark")
              }
              rows="4"
              cols="50"
              required={true}
              value={inputList.manager_remark}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-danger"
            variant="secondary"
            onClick={(e) => handleClose(e)}
          >
            Close
          </Button>
          <Button
            className="btn btn-primary"
            variant="secondary"
            onClick={(e) => {
              handleReject(
                e,
                regularizationDetails?.data?.data[0]?.id,
                regularizationDetails?.data?.data[0]?.regularization_type
              );
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegularizationApproveReject;
